import Builder from '../Builder.js';

export class Before extends Builder {
  static buildMethod = 'before'
  static buildOrder  = 0
  // TODO
}

export default Before